import { Breakpoints, getWindowWidth } from '../grid';

export default function isMobileOrTabletBreakpoint() {
    return getWindowWidth() < Breakpoints.medium;
}
